export interface LeadLike {
  id: number;
  title: string;
  category: string;
  categoryId: string;
  region: string;
  time: string;
  summary: string;
  bounty: number;
  status: string;
  hot: boolean;
  views: number;
  image: string;
}

interface LeadCardProps {
  lead: LeadLike;
}

export default function LeadCard({ lead }: LeadCardProps) {
  const isKey = lead.status === "重点线索";

  return (
    <article
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden bg-background-200">
        <img
          src={lead.image}
          alt={`${lead.title} - 爆料51线索征集`}
          title={`${lead.title} - 爆料51线索征集`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/75 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {lead.category}
        </span>
        {lead.hot ? (
          <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-sm" />
          </span>
        ) : null}
      </div>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          <a href={`/leads?category=${lead.categoryId}`} title={`${lead.title} - 爆料51`}>
            {lead.title}
          </a>
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{lead.summary}</p>

        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line" />
            {lead.region}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {lead.time}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {lead.views}
          </span>
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
          <span
            className={`rounded-md px-2 py-1 text-xs font-medium ${
              isKey ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-800"
            }`}
          >
            {lead.status}
          </span>
          <span className="flex items-center gap-1 font-heading text-base font-bold text-accent-700">
            <i className="ri-hand-coin-line text-sm" />¥{lead.bounty}
          </span>
        </div>
      </div>
    </article>
  );
}